import { AppAreaConfig } from '@/funnels/@types'
import maleActivity from './activity-male'
import femaleActivity from './activity-female-v2'

const mainActivity: AppAreaConfig = {
	appArea: 'main-activity',
	landing: {
		ids: ['loader-activity', 'age-activity'],
		route: {
			path: '/activity',
			name: 'main-activity-funnel',
		},
		overrides: [
			{
				matcher: {
					$and: {
						utm_content: /exercise|workout/,
						utm_campaign: /search|activitygs/,
					},
				},
				ids: ['creatives-exercise'],
			},
			{
				matcher: {
					lptype: 'main_loader', // /activity?safe&lptype=main_loader&lpid=
				},
				ids: ['dynamic-loader', 'dynamic-age-18-50'],
			},
		],
	},
	funnel: {
		id: 'ob-activity-gender-selection',
		route: {
			path: '/activity/ob/:page(.*)?',
			// @ts-expect-error - Legacy: route.name не совпадает с appArea, будет исправлено позже
			name: 'activity-survey',
		},
		slug: 'main-activity',
		theme: 'light',
		locale: ['en', 'de-DE', 'fr-FR', 'tr', 'sv', 'pl', 'pt-BR', 'it-IT', 'es-ES', 'es-419', 'da', 'nb', 'nl'],
		redirectTo: {
			sex: {
				male: { appArea: maleActivity },
				female: { appArea: femaleActivity },
			},
		},
	},
}

export default mainActivity
